<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div :class="noticeTipShow?'content-tip':'content-no-tip'">
    <!--消息通知-->
    <div class="notice-tip-box" v-show="noticeTipShow">
      <van-notice-bar color="#ffffff" background="#F93B3B" left-icon="warning-o">
        退回原因：{{ noticeTipMsg }}
      </van-notice-bar>
    </div>
    <!--消息通知end-->

    <van-form @submit="submitJsy">
      <van-cell-group inset>
        <div class="upload-box">
          <upload-pic-box v-model="indzydimage" :uploadType="deliveryPic" uploadMaxCount="3" :yyid="id" @getUploadInfo="getUploadInfo" :uploadTitle="uploadDeliveryTitle" :uploadRequire="uploadDeliveryRequire" :uploadMultiple="uploadDeliveryMultiple"></upload-pic-box>
          <upload-pic-box v-model="inxhdzydimage" :uploadType="deliveryxhPic" uploadMaxCount="3" :yyid="id" @getUploadInfo="getUploadxhInfo" :uploadTitle="uploadxhDeliveryTitle" :uploadRequire="uploadxhDeliveryRequire" :uploadMultiple="uploadxhDeliveryMultiple" v-if="showxhzyUpload" ></upload-pic-box>
          <van-field v-model="xhbdpinzhong" input-align="right"  required  :rules="[{ validator:validatorDeliveryName, message: '请填写送货单品种' }]" placeholder="请输入">
            <template #label>
              <span class="input-left-label-hq">送货单品种</span>
            </template>
          </van-field>

          <van-field v-model="xhbdsl"  input-align="right" required  :rules="[{ validator:validatorDeliveryWeight, message: '请填写送货单单量（预卸）' }]" placeholder="请输入">
            <template #extra>
              <div class="unit">吨</div>
            </template>
            <template #label>
              <span class="input-left-label-hq">送货单单量（预卸）</span>
            </template>
          </van-field>

          <van-field v-model="chuchangdanweixh" input-align="right"  placeholder="请输入">
            <template #label>
              <span class="input-left-label-hq">出厂单位</span>
            </template>
          </van-field>

          <van-field v-model="kehumingchengxh" input-align="right"  placeholder="请输入">
            <template #label>
              <span class="input-left-label-hq">客户名称</span>
            </template>
          </van-field>

          <van-field v-model="qianfenghao" input-align="right"  placeholder="请输入">
            <template #label>
              <span class="input-left-label-hq">铅封号</span>
            </template>
          </van-field>

        </div>
      </van-cell-group>
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn">
          保存
        </van-button>
      </div>

    </van-form>
  </div>
</div>
</template>
<script>
import api from '@/fetch/api';
import { Toast,Dialog } from "vant"
import Nav from "../Public/navTpl.vue"
import UploadPicBox from "../Public/uploadPicBox.vue"
export default {
  components: {
    Nav,
    UploadPicBox,
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      uploadDeliveryTitle: "送货单图片",
      uploadDeliveryRequire: true,
      uploadDeliveryMultiple:true,
      deliveryPic:"deliveryPic",
      uploadxhDeliveryTitle: "装货时的电子运单图片",
      uploadxhDeliveryRequire: true,
      uploadxhDeliveryMultiple:true,
      deliveryxhPic:"deliveryPic",
      showxhzyUpload: false,
      xhbdpinzhong:"",
      xhbdsl:0,
      chuchangdanweixh:"",
      kehumingchengxh:"",
      qianfenghao:"",
      loadingBtn:false,
      id:"",
      indzydimageArr:[],
      indzydurlArr:[],
      indzydimage:[],
      inxhdzydimageArr:[],
      inxhdzydurlArr:[],
      inxhdzydimage:[],
      noticeTipShow:false,
      noticeTipMsg:"",
    }
  },
  created(){
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getOrderDetail(id);
    this.checkSfscdzyd(id);
  },
  methods:{
    checkSfscdzyd(yyid) {
      var that = this;
      api.getsfscdzyd(yyid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          if (resData.data === "Y") {
            that.showxhzyUpload = true;
            that.uploadxhDeliveryRequire = true;
          } else {
            that.showxhzyUpload = false;
            that.uploadxhDeliveryRequire = false;
          }
        }
      }).catch(function(err) {
        console.log(err);
      });
    },
    getOrderDetail(id) {
      var that = this;
      api.getOrderDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          that.getNoticeTipShow(detail,id+','+'SHD')
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    getNoticeTipShow(detail,id)
    {
      var that = this;
      api.getNoticeTipShow(id).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          if(resData.data && detail.sfscxhzybd == "1"){
            that.noticeTipShow = true;
            that.noticeTipMsg = resData.data;
          }
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function() {
        //Toast.fail('error');
      });
    },
    validatorDeliveryName(val)
    {
      if (!val) {
        Toast.fail('请填写送货单品种');
        return false;
      }
      return val;
    },
    validatorDeliveryWeight(val)
    {
      if (!val) {
        Toast.fail('请填写送货单单量（预卸）');
        return false;
      }
      return val;
    },
    getUploadInfo(imageData){
      this.indzydurlArr = imageData;
    },
    getUploadxhInfo(imageData){
      this.inxhdzydurlArr = imageData;
    },
    submitJsy() {
      var that = this;
      //var openid = that.$store.state.wx_info.openid;
      var xhbdpinzhong = that.xhbdpinzhong ? that.xhbdpinzhong : "";
      var xhbdsl = that.xhbdsl ? that.xhbdsl : 0;
      var chuchangdanweixh = that.chuchangdanweixh ? that.chuchangdanweixh : "";
      var kehumingchengxh = that.kehumingchengxh ? that.kehumingchengxh :"";
      var qianfenghao = that.qianfenghao?that.qianfenghao:"";
      var yyid = this.$data.id;

      var indzydurl = "";
      var indzydurlArr = that.indzydurlArr;
      if (indzydurlArr.length > 0) {
        for (var k = 0; k < indzydurlArr.length; k++) {
          indzydurl += indzydurlArr[k] + ",";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (indzydurl.length > 0) {
          indzydurl = indzydurl.substr(0, indzydurl.length - 1);
        }
      } else {
        Toast.fail('请上传送货单');
        return false;
      }

      var inxhdzydurl = "";
      if (that.showxhzyUpload) {
        var inxhdzydurlArr = that.inxhdzydurlArr;
        if (inxhdzydurlArr.length > 0) {
          for (var m = 0; m < inxhdzydurlArr.length; m++) {
            inxhdzydurl += inxhdzydurlArr[m] + ",";
          }
          //去掉最后一个逗号(如果不需要去掉，就不用写)
          if (inxhdzydurl.length > 0) {
            inxhdzydurl = inxhdzydurl.substr(0, inxhdzydurl.length - 1);
          }
        } else {
          Toast.fail('请上传装货时的电子运单图片');
          return false;
        }
      }

      that.$data.loadingBtn = true;
      //var formData = new FormData();
      var formData = JSON.stringify({
        id: yyid,
        xhbdpinzhong: xhbdpinzhong,
        xhbdurl: indzydurl,
        xhdzydurl: inxhdzydurl,
        xhbdsl: xhbdsl,
        chuchangdanweixh: chuchangdanweixh,
        kehumingchengxh: kehumingchengxh,
        qianfenghao: qianfenghao,
      });
      // formData.append('id', yyid);
      // formData.append('xhbdpinzhong', xhbdpinzhong);
      // formData.append('xhbdurl', indzydurl);
      // formData.append('xhbdsl', xhbdsl);
      // formData.append('chuchangdanweixh', chuchangdanweixh);
      // formData.append('kehumingchengxh',kehumingchengxh);
      // formData.append('qianfenghao',qianfenghao);

      api.submitxhbd(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            that.$router.push({
              name: 'orderdetail',
              params: {
                id: yyid
              }
            });
          });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {

          });
        }
      }).catch(function(err) {
        console.log(err);
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },


  },
}
</script>
<style lang="scss" scoped>

.content-tip{
    margin-top: 7rem; 
}

.content-no-tip{
    margin-top: 4.75rem; 
}

.upload-box {
  background: #fff;
  margin-top: 0.625rem;
}
.unit {
  padding-left: 0.2rem;
  color: #969799;
}

.notice-tip-box{
  position: fixed;
  top: 3.75rem;
  width: 100%;
  z-index: 99;
}

</style>
